export default __webpack_public_path__ + "media/pins/map-pin-blue@2x-e1d6a1af.png";